import { getOrgConfig, defaultAmountField } from "../../../Common/Hooks/OrgConfigHooks";
import { useState, useEffect } from 'react';
import Breadcrumb from '../../../Common/Breadcrumb';
import { APIClient } from "../../../helpers/api_helper";
import { Col, Row, Form } from 'antd';
import BasePieChartWithTable from '../../../Common/BasePieChartWithTable';
import AmountFieldSelect from '../../../Common/AmountFieldSelect';
import { useSelector, useDispatch } from "react-redux";
import utils from '../../../Common/utils';
import { setInitialFilterConf, updateFilterData } from '../../../slices/filters/thunk'
import { Link } from 'react-router-dom';
import ShowIntentsBtn from '../../../Common/ShowIntentsBtn';
import InsightsChartCard from '../../../Common/InsightsChartCard';


const api = new APIClient();


const InsightsIncomes = () => {
  document.title = "Prihodki" + process.env.REACT_APP_PAGE_TITLE;
  const dispatch = useDispatch();
  const filterdata = useSelector((state) => state.Filterdata.data)
  const [incomesByCompanyData, setIncomesByCompanyData] = useState([]);
  const [incomesByProjectData, setIncomesByProjectData] = useState([]);
  const [loadingByCompany, setLoadingByCompany] = useState(false);
  // Which panel, if any, is widened to the full page. Only one at a time.
  const [expandedChart, setExpandedChart] = useState(null);
  const [loadingByProject, setLoadingByProject] = useState(false);

  const loadInsightsData = () => {
    setLoadingByProject(true);
    api.get('/api/insights/incomes_by_project/', utils.toFilterParams(filterdata))
      .then(resp => setIncomesByProjectData(resp))
      .finally(() => setLoadingByProject(false));
    setLoadingByCompany(true);
    api.get('/api/insights/incomes_by_company/', utils.toFilterParams(filterdata))
      .then(resp => setIncomesByCompanyData(resp))
      .finally(() => setLoadingByCompany(false));
  }

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: { amount_field: defaultAmountField(getOrgConfig()) },
      hidden: ['intent_type', 'intent_checkboxes_group'],
      // The checkbox group is hidden wholesale, but a paid filter is needed here:
      // without it these totals mix realised spending with what is only planned.
      shown: ['is_paid'],
      disabled: ['search'],
      masterSearch: true,
    }))
  }, []);



  useEffect(() => {
    loadInsightsData()
  }, [filterdata]);


  return (
    <>
      <Breadcrumb parentTitle="Vpogledi" pageTitle="Prihodki" />
      <>
        <Col xs={24} className="gutter-row">

            <Row>
              <Col span={4}>
                <Form.Item label="Znesek">
                  <AmountFieldSelect
                    value={filterdata.amount_field || defaultAmountField(getOrgConfig())}
                    onChange={val => dispatch(updateFilterData({ amount_field: val }))}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>

              <InsightsChartCard
                chartKey="project"
                title="Po projektu"
                expandedKey={expandedChart}
                onToggleExpanded={setExpandedChart}
                defaultSpan={{ xs: 24, md: 12 }}
                extra={<Link to="/intents"><ShowIntentsBtn/></Link>}
              >
                    <BasePieChartWithTable
                      data={incomesByProjectData}
                      loading={loadingByProject}
                      aggColTitle={'Projekt'}
                      filterName={'projects'}
                      moneyType={'INCOME'}
                    />
              </InsightsChartCard>

              <InsightsChartCard
                chartKey="company"
                title="Po podjetju"
                expandedKey={expandedChart}
                onToggleExpanded={setExpandedChart}
                defaultSpan={{ xs: 24, md: 12 }}
                extra={<Link to="/intents"><ShowIntentsBtn/></Link>}
              >
                    <BasePieChartWithTable
                      data={incomesByCompanyData}
                      loading={loadingByCompany}
                      aggColTitle={'Podjetje'}
                      filterName={'companies'}
                      moneyType={'INCOME'}
                    />
              </InsightsChartCard>
            </Row>

        </Col>
      </>
    </>
  )
}

export default InsightsIncomes;
